import { useFeature } from '@growthbook/growthbook-react';

export type FeatureExperimentValues = string;

const useFeatureExperiment = (conversion: string) => {
  const experimentValue = useFeature<FeatureExperimentValues>(
    conversion
  ).value;
  return experimentValue;
};

export default useFeatureExperiment;
